import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-85e25dd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "fs-18 fw-semibold mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "badge bg-warning text-dark ms-2"
}
const _hoisted_6 = { class: "d-sm-flex align-items-center" }
const _hoisted_7 = { class: "d-flex gap-2" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-85e25dd2>Tous les statuts</option><option value=\"en attente\" data-v-85e25dd2>En attente</option><option value=\"approuvée\" data-v-85e25dd2>Approuvées</option><option value=\"rejetée\" data-v-85e25dd2>Rejetées</option><option value=\"en cours\" data-v-85e25dd2>En cours</option><option value=\"terminée\" data-v-85e25dd2>Terminées</option>", 6)
const _hoisted_14 = [
  _hoisted_8
]
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_19 = { class: "table-responsive" }
const _hoisted_20 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Document demandé "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date Debut "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date Fin "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Motif demande "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Demandeur "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date demande "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Statut "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
    }, " ACTIONS ")
  ])
], -1))
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-body-tertiary pe-0" }
const _hoisted_30 = { class: "dropdown" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1))
const _hoisted_32 = { class: "dropdown-menu" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "fa fa-edit lh-1 me-8 position-relative top-1"
}
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_39 = { key: 2 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash-o lh-1 me-8 position-relative top-1" }, null, -1))
const _hoisted_42 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_43 = {
  ref: "modalRef",
  class: "modal fade",
  id: "detailsDemandeModal",
  tabindex: "-1",
  "aria-labelledby": "detailsDemandeModalLabel",
  "aria-hidden": "true"
}
const _hoisted_44 = { class: "modal-dialog modal-lg" }
const _hoisted_45 = { class: "modal-content" }
const _hoisted_46 = { class: "modal-header" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "detailsDemandeModalLabel"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle me-2" }),
  /*#__PURE__*/_createTextVNode(" Détails de la demande d'emprunt ")
], -1))
const _hoisted_48 = { class: "modal-body" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "card mb-3" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-primary text-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0 text-white" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-book me-2" }),
    /*#__PURE__*/_createTextVNode(" Informations sur la demande ")
  ])
], -1))
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Document demandé :")
], -1))
const _hoisted_56 = { class: "text-muted" }
const _hoisted_57 = { class: "col-md-4" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date de demande :")
], -1))
const _hoisted_59 = { class: "text-muted" }
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Statut :")
], -1))
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date de début :")
], -1))
const _hoisted_64 = { class: "text-muted" }
const _hoisted_65 = { class: "col-md-4" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date de fin :")
], -1))
const _hoisted_67 = { class: "text-muted" }
const _hoisted_68 = { class: "row" }
const _hoisted_69 = { class: "col-12" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Motif de la demande :")
], -1))
const _hoisted_71 = { class: "text-muted p-2 bg-light rounded" }
const _hoisted_72 = { class: "card mb-3" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-info text-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user me-2" }),
    /*#__PURE__*/_createTextVNode(" Informations du demandeur ")
  ])
], -1))
const _hoisted_74 = { class: "card-body" }
const _hoisted_75 = { class: "row" }
const _hoisted_76 = { class: "col-md-6" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nom complet :")
], -1))
const _hoisted_78 = { class: "text-muted" }
const _hoisted_79 = { class: "col-md-6" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email :")
], -1))
const _hoisted_81 = { class: "text-muted" }
const _hoisted_82 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-warning text-dark" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-comment me-2" }),
    /*#__PURE__*/_createTextVNode(" Motif de traitement ")
  ])
], -1))
const _hoisted_84 = { class: "card-body" }
const _hoisted_85 = { class: "mb-0 p-2 bg-light rounded fst-italic" }
const _hoisted_86 = { class: "modal-footer" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times me-2" }, null, -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-edit me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, [
            _createTextVNode(" Liste des demandes d'emprunt "),
            (_ctx.demandesEnAttente > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.demandesEnAttente) + " en attente ", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtreStatut) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              style: {"min-width":"150px"}
            }, _hoisted_14, 544), [
              [_vModelSelect, _ctx.filtreStatut]
            ]),
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event)),
                onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["enter"])),
                placeholder: "Rechercher par titre, demandeur..."
              }, null, 544), [
                [_vModelText, _ctx.searchTerm]
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary",
                type: "button",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)))
              }, _hoisted_17)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("table", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_22, _toDisplayString(document?.documentTitre), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.format_Date(document.dateDebut)), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.format_Date(document.dateFin)), 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(document?.motif), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(document?.user?.nom) + " " + _toDisplayString(document?.user?.prenoms), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.format_Date(document.createdAt)), 1),
                  _createElementVNode("td", _hoisted_28, [
                    _createElementVNode("span", {
                      class: _normalizeClass([_ctx.getStatutBadgeClass(document?.statut), "badge fs-12 fw-medium"])
                    }, _toDisplayString(document?.statut), 3)
                  ]),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("ul", _hoisted_32, [
                        (document?.statut?.toLowerCase() === 'en attente' || document?.statut?.toLowerCase() === 'attente')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_33, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.traiterDemande(document))
                              }, [
                                (_ctx.checkPermission('ViewEmprunt'))
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" Traiter demande ")
                              ], 8, _hoisted_34)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('ViewEmprunt'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_36, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.voirDetails(document))
                              }, [
                                _hoisted_38,
                                _createTextVNode(" Détails demande ")
                              ], 8, _hoisted_37)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('DeleteEmprunt'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_39, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.suppression(document.id, _ctx.documents, 'documents', `Demande ${document.id}`))
                              }, [
                                _hoisted_41,
                                _createTextVNode(" Supprimer demande ")
                              ], 8, _hoisted_40)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.fermerModal && _ctx.fermerModal(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_48, [
            (_ctx.selectedDemande)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", _hoisted_54, [
                          _hoisted_55,
                          _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.selectedDemande.documentTitre || 'Non spécifié'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.format_Date(_ctx.selectedDemande.createdAt)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createElementVNode("span", {
                            class: _normalizeClass([_ctx.getStatutBadgeClass(_ctx.selectedDemande.statut), "badge fs-14 fw-medium"])
                          }, _toDisplayString(_ctx.selectedDemande.statut), 3)
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.format_Date(_ctx.selectedDemande.dateDebut)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.format_Date(_ctx.selectedDemande.dateFin)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.selectedDemande.motif || 'Aucun motif spécifié'), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _createElementVNode("p", _hoisted_78, _toDisplayString(_ctx.selectedDemande.user?.nom || '') + " " + _toDisplayString(_ctx.selectedDemande.user?.prenoms || ''), 1)
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _hoisted_80,
                          _createElementVNode("p", _hoisted_81, _toDisplayString(_ctx.selectedDemande.user?.email || 'Non spécifié'), 1)
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.motifTraitement)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                        _hoisted_83,
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("p", _hoisted_85, _toDisplayString(_ctx.motifTraitement), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fermerModal && _ctx.fermerModal(...args)))
            }, [
              _hoisted_87,
              _createTextVNode(" Fermer ")
            ]),
            (_ctx.selectedDemande && (_ctx.selectedDemande.statut?.toLowerCase() === 'en attente' || _ctx.selectedDemande.statut?.toLowerCase() === 'attente'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.traiterDemandeFromModal && _ctx.traiterDemandeFromModal(...args)))
                }, [
                  _hoisted_88,
                  _createTextVNode(" Traiter la demande ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 512)
  ], 64))
}